import { get, post } from './apiClient';

export function joinCommunity(payload) {
  return post('/join-community', payload);
}

export function getCommunity() {
  return get('/join-community').then((data) => data.coordinates);
}